module.exports = __webpack_public_path__ + "img/17.37e7f294.svg";